/**
 * Nurse Supervisory Visit — static options + empty form state.
 * Sections mirror Eval & Orders → Nurse Supervisory Visit screenshots.
 */

import { emptyNurseNotesCommonHeader } from "./nurseNotesCommonHeaderUtils";
import { emptyWoundAssessmentValues } from "./woundAssessmentContent";

export const YES_NO_OPTIONS = ["Yes", "No"];

export const SUPERVISORY_VISIT_TYPE_OPTIONS = [
  "Routine (Per Plan of Care)",
  "Resumption of Care",
  "Recertification",
  "Significant Change in Condition",
  "OASIS Follow-up",
  "Other",
];

export const VISIT_LOCATION_OPTIONS = [
  "Patient Home",
  "Assisted Living Facility",
  "Nursing Facility",
  "Other",
];

export const PARTICIPANT_OPTIONS = [
  "Supervising Nurse (RN/LPN)",
  "Patient",
  "Caregiver/Family",
  "Other Staff",
];

/** CMS 42 CFR §484.80 supervisory visit requirements. */
export const REQUIREMENTS_CHECKLIST_OPTIONS = [
  "Assessed patient's condition and any changes since last visit.",
  "Assessed the patient's progress toward goals/outcomes.",
  "Evaluated the appropriateness and effectiveness of the care provided.",
  "Determined if the Plan of Care remains appropriate.",
  "Reviewed all medications and any medication changes.",
  "Evaluated patient/caregiver understanding of the plan of care.",
  "Assessed safety of the environment.",
  "Verified that services are being provided as ordered.",
  "Addressed any problems or issues and revised plan as needed.",
  "Communicated findings with the patient, caregiver, and care team.",
];

export const GENERAL_APPEARANCE_OPTIONS = [
  "Stable",
  "Improved",
  "Declined",
  "Other",
];

export const SKIN_INTEGRITY_OPTIONS = [
  "Intact",
  "At Risk",
  "Impaired",
  "Other",
];

export const FUNCTIONAL_STATUS_OPTIONS = [
  "Independent",
  "Requires Assistance",
  "Dependent",
];

export const EDUCATION_TOPIC_OPTIONS = [
  "Disease Process",
  "Medications",
  "Safety",
  "Other",
];

export const EDUCATION_RESPONSE_OPTIONS = [
  "Verbalized Understanding",
  "Needs Reinforcement",
  "Not Applicable",
];

export const COMMUNICATION_WITH_OPTIONS = [
  "Patient",
  "Caregiver/Family",
  "Physician",
  "Other Staff",
];

export const COMMUNICATION_METHOD_OPTIONS = [
  "In Person",
  "Phone",
  "Electronic",
];

export const toggleInList = (list, item) => {
  const arr = Array.isArray(list) ? list : [];
  return arr.includes(item) ? arr.filter((x) => x !== item) : [...arr, item];
};

export const today = () => new Date().toISOString().slice(0, 10);

/** Full editable Nurse Supervisory Visit payload (JSON on dedicated row). */
export const emptyRnSupVisitPayload = () => ({
  billingCode: "",
  timeIn: "",
  timeOut: "",

  commonHeader: emptyNurseNotesCommonHeader(),

  patientName: "",
  mrn: "",
  dateOfBirth: "",
  address: "",
  city: "",
  state: "",
  zip: "",
  phone: "",
  insurance: "",
  certPeriodFrom: "",
  certPeriodTo: "",

  visitDate: "",
  supervisoryVisitType: "",
  supervisoryVisitTypeOther: "",
  visitLocation: "Patient Home",
  visitLocationOther: "",
  participants: ["Supervising Nurse (RN/LPN)"],
  participantsOther: "",

  requirementsChecklist: [],

  vitalsBp: "",
  vitalsHr: "",
  vitalsRr: "",
  vitalsTemp: "",
  vitalsSpo2: "",
  vitalsWeight: "",
  painLevel: null,

  ...emptyWoundAssessmentValues(),

  generalAppearance: [],
  generalAppearanceOther: "",
  skinIntegrity: [],
  skinIntegrityOther: "",
  functionalStatus: [],
  clinicalComments: "",
  educationTopics: [],
  educationOther: "",
  educationResponse: [],

  planOfCareReviewed: "",
  planRemainsAppropriate: "",
  planRevisions: "",
  newOrdersInstructions: "",
  followUpRequired: "",
  followUpSpecify: "",

  communicationWith: [],
  communicationMethod: [],
  communicationOther: "",
  communicationSummary: "",
});
